type PlusAccordionIcon = {
  svgClasses: string;
  lineClasses: string;
};

const PlusAccordionIcon = ({ svgClasses, lineClasses }: PlusAccordionIcon) => (
  <svg viewBox="0 0 24 24" className={svgClasses}>
    <line className={lineClasses} x1="12" y1="6" x2="12" y2="18"></line>

    <line className="line line2" x1="6" y1="12" x2="18" y2="12"></line>
  </svg>
);

export default PlusAccordionIcon;
